import { HTMLAttributes } from 'react'

import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  head?: boolean
  noBorder?: boolean
  attributes?: HTMLAttributes<HTMLTableRowElement>
  hoveredOn?: boolean
}

const TableRow = ({
  children,
  head = false,
  noBorder = false,
  hoveredOn = false,
  attributes
}: Props) => {
  return (
    <tr
      role='row'
      className={clsx(
        !noBorder && 'border-secondary border-b border-solid last:border-none',
        head ? 'bg-surface-secondary' : hoveredOn && 'hover:bg-gray-100'
      )}
      {...attributes}
    >
      {children}
    </tr>
  )
}

export default TableRow
